/// <reference types="office-js" />

import {bootstrapApplication} from '@angular/platform-browser';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {importProvidersFrom, Injectable} from '@angular/core';
import {APP_ROUTES} from './app/app.routes';
import {AppComponent} from './app/app.component';
import {JWTInterceptor} from '@core/auth/interceptor/jwt.interceptor';
import {NgxMaskConfig, provideEnvironmentNgxMask} from 'ngx-mask';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MarkdownModule} from 'ngx-markdown';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {MatDialogModule} from "@angular/material/dialog";
import {LocalizationInterceptor} from "@core/interceptors/localization.interceptor";
import {AnimationService} from "@core/services/anmation.service";

// Custom location strategy for Outlook Add-in
@Injectable()
export class OutlookLocationStrategy extends HashLocationStrategy {
	override replaceState(state: any, title: string, url: string, queryParams: string): void {
		try {
			super.replaceState(state, title, url, queryParams);
		} catch (e) {
			// Fallback for Outlook Add-in environment
			this.pushState(state, title, url, queryParams);
		}
	}

	override pushState(state: any, title: string, url: string, queryParams: string): void {
		try {
			super.pushState(state, title, url, queryParams);
		} catch (e) {
			// Fallback for Outlook Add-in environment
			window.location.hash = url + (queryParams ? '?' + queryParams : '');
		}
	}
}

const maskConfig: Partial<NgxMaskConfig> = {
	validation: false,
};

const providers = [
	provideEnvironmentNgxMask(maskConfig),
	{provide: HTTP_INTERCEPTORS, useClass: LocalizationInterceptor, multi: true},
	{provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true},
	{provide: LocationStrategy, useClass: OutlookLocationStrategy},
	provideRouter(APP_ROUTES, withComponentInputBinding()),
	provideHttpClient(withInterceptorsFromDi()),
	importProvidersFrom([
		MatNativeDateModule,
		BrowserAnimationsModule,
		MatSnackBarModule,
		MarkdownModule.forRoot(),
		AnimationService,
	]),
];

// Bootstrap the application
bootstrapApplication(AppComponent, {providers}).catch(err => console.error(err));
